import { ref, watch, type Ref } from 'vue';
import type { SyncScope } from '@/composables/api/useSchedulerSyncApi';

/**
 * Mine or Everyone for the Sync pill and its popover. One selection, shared,
 * so the pill's count always describes what the popover lists. Remembered per
 * browser. Storage can be missing or throw (private mode, blocked site data),
 * so every read and write is guarded and the default is Mine.
 */
export const SYNC_SCOPE_STORAGE_KEY = 'sync-status:scope:v1';

export function readStoredSyncScope(): SyncScope {
    try {
        const stored = window.localStorage.getItem(SYNC_SCOPE_STORAGE_KEY);
        return stored === 'everyone' ? 'everyone' : 'mine';
    } catch {
        return 'mine';
    }
}

let sharedScope: Ref<SyncScope> | null = null;

export function useSyncScope(): Ref<SyncScope> {
    if (sharedScope === null) {
        const scope = ref<SyncScope>(readStoredSyncScope());
        watch(scope, (nextScope) => {
            try {
                window.localStorage.setItem(SYNC_SCOPE_STORAGE_KEY, nextScope);
            } catch {
                // A choice that does not persist still applies for this page.
            }
        });
        sharedScope = scope;
    }
    return sharedScope;
}

/** Test seam: forget the shared selection so the next call reads storage again. */
export function resetSyncScopeForTests(): void {
    sharedScope = null;
}
